const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class PaymentMethodCommandConnector {
  constructor(configuration) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);
  }

  async list({ paymentProviderName }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/payment/methods/me`, {
        params: {
          paymentProviderName,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getCardsList({ paymentProviderName }) {
    try {
      const { data } = await this.httpClient.get('/v2/payment/methods/me', {
        params: {
          paymentProviderName,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getClientSecret({ paymentProviderName }) {
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/payment/methods`, { paymentProviderName });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async storeCard({ id, paymentProviderName }) {
    assert(id, 'Expected id');
    assert(paymentProviderName, 'Expected paymentProviderName');

    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/payment/methods/${id}`, { paymentProviderName });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteCard({ id, paymentProviderName }) {
    assert(id, 'expected paymentMethodId');
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/payment/methods/${id}`, { data: { paymentProviderName } });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  PaymentMethodCommandConnector,
};
